'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var projectTypeImg = {
  audio: require('./assets/audio.png'),
  video: require('./assets/video.png'),
  sharespace: require('./assets/sharespace.png')
};

var ProjectTypeIcon = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(ProjectTypeIcon, _PureComponent);

  function ProjectTypeIcon() {
    (0, _classCallCheck3.default)(this, ProjectTypeIcon);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectTypeIcon.__proto__ || (0, _getPrototypeOf2.default)(ProjectTypeIcon)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectTypeIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          type = _props.type;


      return _react2.default.createElement('img', {
        className: (0, _bind2.default)(className),
        src: projectTypeImg[type] || projectTypeImg.audio,
        alt: ''
      });
    }
  }]);
  return ProjectTypeIcon;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  type: _propTypes2.default.string
}, _temp);
exports.default = ProjectTypeIcon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectTypeIcon/ProjectTypeIcon.js
// module id = 2061
// module chunks = 1